import React from "react";
import { Link } from 'react-router-dom';

import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { adobeColor, iconSize } from "../App/GridRenderers";




const YouTubeIcon = ({ mt = 0 }) => {
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="YouTube Videos"
                    enterDelay={1000}>
                    <Link
                        to={"https://www.youtube.com/@MyOwnFP"}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon
                            icon={faYoutube}
                            color={adobeColor}
                            size={iconSize}
                        />
                    </Link>
                </Tooltip>
            </Stack>
        </div >
    );
};

export default YouTubeIcon;